import { __rest } from "tslib";
import clsx from 'clsx';
import React, { forwardRef, memo } from 'react';
const ModalBody = (_a, ref) => {
    var { className, tag: Tag = 'div' } = _a, attributes = __rest(_a, ["className", "tag"]);
    const classes = clsx(className, 'modal__body');
    return React.createElement(Tag, Object.assign({}, attributes, { ref: ref, className: classes }));
};
export default memo(forwardRef(ModalBody));
//# sourceMappingURL=ModalBody.js.map